import React from "react";
import PropTypes from "prop-types";

import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import IconButton from "@material-ui/core/IconButton";
import SettingsIcon from "@material-ui/icons/Settings";

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  inline: {
    display: "flex",
  },
}));

const EnhancedTableToolbar = props => {
  const { title, rows, selected, deleteHandler, expandHandler, deleteButton, filterList, settingsCallback } = props;

  const classes = useToolbarStyles();
  const numSelected = selected.length;
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            {title}
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 && deleteButton && (
          <Tooltip title="Delete">
            <IconButton
              aria-label="Delete"
              onClick={() => deleteHandler(selected.map(idx => rows.find(row => idx === row.selectIndex)))}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
        <div className={classes.inline}>
          {settingsCallback && (
            <Tooltip title="Settings">
              <IconButton aria-label="Settings" onClick={() => settingsCallback()}>
                <SettingsIcon />
              </IconButton>
            </Tooltip>
          )}
          {filterList && (
            <Tooltip title="Filter list">
              <IconButton aria-label="Filter list" onClick={() => expandHandler()}>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.defaultProps = {
  deleteButton: true,
  settingsCallback: undefined,
};

EnhancedTableToolbar.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  deleteHandler: PropTypes.func.isRequired,
  expandHandler: PropTypes.func.isRequired,
  deleteButton: PropTypes.bool,
  filterList: PropTypes.bool.isRequired,
  settingsCallback: PropTypes.func,
};

export default EnhancedTableToolbar;
